<div bp-goal-detail-card>
  <div>
    @if (isGeneralBalance) {
      <!-- <div class="truncate text-xl font-bold pb-6 hidden sm:block">Evolución Balance</div> -->
      <div bp-title-card class="truncate pb-6 hidden sm:block">Evolución Balance</div>

      <!-- <div class="w-full h1 mt-auto border-t-2 hidden sm:block"></div> -->
      <div class="flex flex-row justify-stretch pt-0 pb-0 sm:pb-6">
        <div class="flex flex-col w-full gap-1">
          <div class="truncate">
            Balance
            <mat-icon
              class="text-base text-default relative icon-size-4 -bottom-[3px]"
              [svgIcon]="'mat_outline:help_outline'"
              matTooltip="Incluye los depositos pendientes, retiros y transferencias entre metas."
              #favoriteGoalTooltip="matTooltip"
              (click)="favoriteGoalTooltip.toggle()"
            >
            </mat-icon>
          </div>

          <div
            class="text-3xl font-semibold leading-6 tracking-tight"
            [bp-skeleton]="isLoading || currency?.id === 0"
            skeletonHeight="6"
            skeletonWidth="30"
          >
            {{
              (totalCurrentCapital ?? 0) && hasAllFinancialInstitutions
                ? (totalCurrentCapital ?? 0
                  | currency: currency?.currencyCode : currency?.display : currency?.digitsInfo)
                : (balanceTotalAmount ?? 0
                  | currency: currency?.currencyCode : currency?.display : currency?.digitsInfo)
            }}
          </div>
          <div
            class="text-base sm:hidden block"
            [bp-skeleton]="isMobile && (isLoading || currency?.id === 0)"
            skeletonHeight="6"
            skeletonWidth="80"
          >
            <span class="text-charts-green-700">
              {{
                (totalCurrentCapital ?? 0) && hasAllFinancialInstitutions
                  ? (variation ?? 0
                    | currency: currency?.currencyCode : currency?.display : currency?.digitsInfo)
                  : (variation ?? 0
                    | currency: currency?.currencyCode : currency?.display : currency?.digitsInfo)
              }}
            </span>
            variación
            @if (groupFilterInfo?.timePeriod?.value === 7) {
              <span class="lowercase">
                {{ groupFilterInfo?.timePeriod?.dateFromFormated }} -
                {{ groupFilterInfo?.timePeriod?.dateToFormated }}</span
              >
            } @else {
              <span class="lowercase"> {{ groupFilterInfo?.timePeriod?.labels?.[0] }}</span>
            }
          </div>
        </div>
        <div class="flex flex-col w-full hidden sm:flex gap-1">
          <div class="truncate">
            Variación
            @if (groupFilterInfo?.timePeriod?.value === 7) {
              <span class="lowercase">
                {{ groupFilterInfo?.timePeriod?.dateFromFormated }} -
                {{ groupFilterInfo?.timePeriod?.dateToFormated }}</span
              >
            } @else {
              <span class="lowercase"> {{ groupFilterInfo?.timePeriod?.labels?.[0] }}</span>
            }
          </div>

          <div
            class="text-3xl font-semibold leading-6 tracking-tight"
            [bp-skeleton]="isLoading || currency?.id === 0"
            skeletonHeight="6"
            skeletonWidth="30"
          >
            {{
              (totalCurrentCapital ?? 0) && hasAllFinancialInstitutions
                ? (variation ?? 0
                  | currency: currency?.currencyCode : currency?.display : currency?.digitsInfo)
                : (variation ?? 0
                  | currency: currency?.currencyCode : currency?.display : currency?.digitsInfo)
            }}
          </div>
        </div>
      </div>
    } @else {
      <div bp-title-card class="truncate">Balance</div>
    }
    @if (showDates && !isGeneralBalance) {
      <div bp-text-values-card class="truncate">
        {{ fixedFromDate + ' - ' + fixedToDate }}
      </div>
    }
  </div>
  <div class="flex flex-col justify-between gap-0">
    <!-- Chart -->
    @if (!balance && !isLoading) {
      <div class="px-6 font-medium h6">
        Verás tu balance una vez que tu depósito haya sido invertido
      </div>
    }

    <div class="flex-1 px-0 pt-0">
      <div style="width: 100%">
        @if (isLoading) {
          <no-data-chart></no-data-chart>
        }
        @if (!isLoading && !singleChart) {
          @if (balance) {
            <app-g-p-b-chart
              [isGeneralBalance]="isGeneralBalance"
              [balance]="balance"
              [currency]="currency"
            ></app-g-p-b-chart>
          }
        }
        @if (!isLoading && singleChart) {
          @if (balanceSingle) {
            <app-g-p-b-chart-single
              [balance]="balanceSingle"
              [currency]="currency"
            ></app-g-p-b-chart-single>
          }
        }
      </div>
    </div>
    <!-- BOTONERA TIEMPOS EN RESPONSIVE -->
    @if (isGeneralBalance) {
      <div class="flex flex-col sm:hidden pt-5 sm:pt-0">
        <mat-button-toggle-group
          [hideSingleSelectionIndicator]="true"
          [formControl]="balanceChartontrol"
          class="relative flex flex-row justify-center md:justify-start -top-[35px] my-button-toggle-group"
        >
          <mat-button-toggle value="3m">3M</mat-button-toggle>
          <mat-button-toggle value="6m">6M</mat-button-toggle>
          @if (goalYears >= 1) {
            <mat-button-toggle value="1y">1A</mat-button-toggle>
          }
          @if (goalYears >= 2) {
            <mat-button-toggle class="hidden xl:block" value="2y">2A</mat-button-toggle>
          }
          @if (goalYears >= 3) {
            <mat-button-toggle class="hidden xl:block" value="3y">3A</mat-button-toggle>
          }
          <mat-button-toggle value="all">TODO</mat-button-toggle>
          <mat-button-toggle value="thisyear">{{ thisYear }}</mat-button-toggle>
          @if (wasTheGoalCreatedThePastYear) {
            <mat-button-toggle class="hidden xl:block" value="pastyear">{{
              pastYear
            }}</mat-button-toggle>
          }
          @if (wasTheGoalCreatedThePastPastYear) {
            <mat-button-toggle class="hidden xl:block" value="pastPastyear">{{
              pastPastYear
            }}</mat-button-toggle>
          }
        </mat-button-toggle-group>
      </div>
    }
    <!-- {{ groupFilterInfo?.timePeriod | json }} -->
    @if (hasAllFinancialInstitutions) {
      <div>
        <p class="py-2 text-left help-text">
          El gráfico muestra los datos hasta el último día en que ambas instituciones tienen el
          valor de sus fondos publicados.
        </p>
      </div>
    }

    @if (isGeneralBalance) {
      <!-- Habilitar detalle on and off -->
      <a
        class="sm:mt-0 -mt-5"
        [ngClass]="showDetailTable ? 'pb-6' : ''"
        bp-link
        (click)="showDetailTableToggle()"
      >
        @if (showDetailTable) {
          Ocultar
        } @else {
          Ver
        }
        detalles del balance</a
      >
    }
    @if (showDetailTable || !isGeneralBalance) {
      <!-- Table -->
      <app-g-p-b-table
        @fadeIn
        [totalCurrentCapital]="totalCurrentCapital"
        [dateFinalBalance]="dateFinalBalance"
        [hasAllFinancialInstitutions]="hasAllFinancialInstitutions"
        [balanceTotalAmount]="balanceTotalAmount"
        [balanceTotalDate]="balanceTotalDate"
        [deposits]="deposits"
        [withdrawals]="withdrawals"
        [balanceInitDate]="balanceInitDate"
        [netDeposit]="netDeposit"
        [balanceInitAmount]="balanceInitAmount"
        [currency]="currency"
        [variation]="variation"
        [irrAccumulated]="irrAccumulated"
        [irrAccumulatedUSD]="irrAccumulatedUSD"
        [isGeneralBalance]="isGeneralBalance"
      >
      </app-g-p-b-table>
    }
  </div>
</div>
